import React from 'react';

/* eslint-disable */

export default () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.53547 1.87871C7.92599 2.26923 7.92599 2.9024 7.53547 3.29292L4.70704 6.12135C4.31652 6.51187 3.68335 6.51187 3.29283 6.12135L0.464402 3.29292C0.0738777 2.9024 0.0738777 2.26923 0.464402 1.87871C0.854926 1.48818 1.48809 1.48818 1.87862 1.87871L3.99994 4.00003L6.12126 1.87871C6.51178 1.48818 7.14495 1.48818 7.53547 1.87871Z" fill="#747F98" />
  </svg>
)
